export default __webpack_public_path__ + "static/media/updated.114d8620.svg";